import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const HizmetAl: React.FC = () => {
  const [cityDistrictData, setCityDistrictData] = useState<Record<string, string[]>>({});
  const [cities, setCities] = useState<string[]>([]);
  const navigate = useNavigate();

  // KVKK Modal Component
  const KVKKModal: React.FC<{
    isOpen: boolean;
    onClose: () => void;
    onAccept: () => void;
  }> = ({ isOpen, onClose, onAccept }) => {
    if (!isOpen) return null;

    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Kişisel Verilerin Korunması Kanunu (KVKK)</h3>
            <button className="modal-close" onClick={onClose}>&times;</button>
          </div>
          <div className="modal-body">
            <div className="kvkk-content">
              <h4>1. Veri Sorumlusu</h4>
              <p>Motopack Lojistik ve Teknoloji Anonim Şirketi olarak, kişisel verilerinizin işlenmesi konusunda veri sorumlusu sıfatıyla hareket etmekteyiz.</p>

              <h4>2. Kişisel Verilerin İşlenme Amacı</h4>
              <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
              <ul>
                <li>Kurye hizmeti taleplerinizi değerlendirmek</li>
                <li>Size özel teklifler sunmak</li>
                <li>Hizmet kalitesini artırmak</li>
                <li>Yasal yükümlülüklerimizi yerine getirmek</li>
              </ul>

              <h4>3. İşlenen Kişisel Veri Türleri</h4>
              <p>İşlenen kişisel veri türleri şunlardır:</p>
              <ul>
                <li>Kimlik bilgileri (ad, soyad, T.C. kimlik numarası)</li>
                <li>İletişim bilgileri (telefon, e-posta, adres)</li>
                <li>Firma bilgileri (firma adı, vergi numarası)</li>
                <li>Hizmet talebi bilgileri</li>
              </ul>

              <h4>4. Kişisel Verilerin Aktarılması</h4>
              <p>Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda, yasal düzenlemelerin öngördüğü sınırlar dahilinde, aşağıdaki taraflarla paylaşılabilir:</p>
              <ul>
                <li>Hizmet aldığımız tedarikçiler</li>
                <li>Yasal yükümlülükler gereği kamu kurumları</li>
                <li>Yetkili mahkemeler ve icra müdürlükleri</li>
              </ul>

              <h4>5. İletişim</h4>
              <p>Kişisel verilerinizle ilgili her türlü soru, görüş ve talepleriniz için:</p>
              <ul>
                <li><strong>E-posta:</strong> kvkk@motopack.com.tr</li>
                <li><strong>Adres:</strong> Güzeloluk Mah. 1830. Sk. Florya Sitesi No: 202, Kapı No: B Muratpaşa/Antalya/Türkiye</li>
                <li><strong>Telefon:</strong> 0850 532 59 89</li>
              </ul>

              <h4>6. Haklarınız</h4>
              <p>KVKK'nın 11. maddesi uyarınca sahip olduğunuz haklar:</p>
              <ul>
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
                <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
                <li>Kişisel verilerinizin aktarıldığı üçüncü kişilere yukarıda sayılan hakların uygulanmasını isteme</li>
                <li>İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişiliğinize aleyhtar bir sonucun ortaya çıkmasına itiraz etme</li>
                <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini isteme</li>
              </ul>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={() => {
                onAccept();
                onClose();
              }}
            >
              Okudum ve Onaylıyorum
            </button>
          </div>
        </div>
      </div>
    );
  };

  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    sector: '',
    serviceType: '',
    numberOfPeople: '',
    startDate: '',
    description: '',
    city: '',
    district: '',
    taxNumber: '',
    companyAddress: '',
    discovery: '', // Yeni eklenen alan
    kvkkOnay: false,
    bilgiDogrulugu: false,
    vergiLevhası: null as File | null,
    isyeriFaaliyetBelgesi: null as File | null
  });

  // Hizmet türü seçenekleri sektöre göre
  const serviceTypeOptions: Record<string, { value: string, label: string }[]> = {
    kargo: [
      { value: 'motorlu', label: 'Motorlu kurye' },
      { value: 'aracli', label: 'Araçlı kurye' }
    ],
    restoran: [
      { value: 'motorlu', label: 'Motorlu kurye' },
      { value: 'escooter', label: 'E-scooter Kurye' }
    ],
    market: [
      { value: 'motorlu', label: 'Motorlu kurye' },
      { value: 'aracli', label: 'Araçlı kurye' },
      { value: 'escooter', label: 'E-scooter Kurye' }
    ],
    diger: [
      { value: 'motorlu', label: 'Motorlu kurye' },
      { value: 'aracli', label: 'Araçlı kurye' },
      { value: 'escooter', label: 'E-scooter Kurye' }
    ]
  };

  useEffect(() => {
    fetch('/turkiye_il_ilce.json')
      .then(res => res.json())
      .then((data: Record<string, string[]>) => {
        setCityDistrictData(data);
        setCities(Object.keys(data));
      });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    // Eğer sektör değişiyorsa, hizmet türünü sıfırla
    if (name === 'Sektör') {
      setFormData(prev => ({
        ...prev,
        [name]: value,
        serviceType: ''
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const city = e.target.value;
    setFormData(prev => ({
      ...prev,
      city,
      district: '' // şehir değişince ilçe sıfırlanır
    }));
  };
  const handleDistrictChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const district: string = e.target.value;
    setFormData(prev => ({
      ...prev,
      district
    }));
  };

  const [isKVKKModalOpen, setIsKVKKModalOpen] = useState(false);
  const [fileNames, setFileNames] = useState<Record<string, string>>({});
  const [fileErrors, setFileErrors] = useState<Record<string, string>>({});
  const [filePreviews, setFilePreviews] = useState<Record<string, string>>({});

  // Dosya yükleme alanı bileşeni
  const FileUploadField: React.FC<{
    id: string;
    name: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    accept?: string;
    description?: string;
  }> = ({ id, name, label, required = false, disabled = false, accept = ".pdf,.jpg,.jpeg,.png", description }) => {
    const file = name === 'Vergi Levhası' ? formData.vergiLevhası : formData.isyeriFaaliyetBelgesi;
    const hasFile = Boolean(file);
    const fileError = fileErrors[name];

    const validateFile = (file: File): { isValid: boolean; error?: string } => {
      const maxSize = 5 * 1024 * 1024; // 5MB
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

      if (file.size > maxSize) {
        return { isValid: false, error: 'Dosya boyutu 5MB\'dan büyük olamaz.' };
      }

      if (!allowedTypes.includes(file.type)) {
        return { isValid: false, error: 'Sadece PDF, JPG, JPEG ve PNG dosyaları kabul edilir.' };
      }

      return { isValid: true };
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files?.[0];
      if (selectedFile) {
        const validation = validateFile(selectedFile);
        if (validation.isValid) {
          if (name === 'Vergi Levhası') {
            setFormData(prev => ({
              ...prev,
              vergiLevhası: selectedFile
            }));
          } else {
            setFormData(prev => ({
              ...prev,
              isyeriFaaliyetBelgesi: selectedFile
            }));
          }
          setFileNames(prev => ({
            ...prev,
            [name]: selectedFile.name
          }));
          setFileErrors(prev => ({
            ...prev,
            [name]: ''
          }));

          // Dosya önizleme oluştur
          if (selectedFile.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
              setFilePreviews(prev => ({
                ...prev,
                [name]: e.target?.result as string
              }));
            };
            reader.readAsDataURL(selectedFile);
          } else if (selectedFile.type === 'application/pdf') {
            const reader = new FileReader();
            reader.onload = (e) => {
              setFilePreviews(prev => ({
                ...prev,
                [name]: e.target?.result as string
              }));
            };
            reader.readAsDataURL(selectedFile);
          }
        } else {
          setFileErrors(prev => ({
            ...prev,
            [name]: validation.error || ''
          }));
          e.target.value = '';
        }
      }
    };

    const removeFile = () => {
      if (name === 'Vergi Levhası') {
        setFormData(prev => ({
          ...prev,
          vergiLevhası: null
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          isyeriFaaliyetBelgesi: null
        }));
      }
      setFileNames(prev => {
        const newNames = { ...prev };
        delete newNames[name];
        return newNames;
      });
      setFileErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
      setFilePreviews(prev => {
        const newPreviews = { ...prev };
        delete newPreviews[name];
        return newPreviews;
      });
    };

    const getIcon = () => {
      if (name === 'Vergi Levhası' || name === 'İşyeri Faaliyet Belgesi') {
        return '/icon/belge/adlisicil.png';
      }
      return '📁'; // Varsayılan ikon
    };

    return (
      <div className="form-group">
        <label htmlFor={id}>{label} {required && '*'}</label>
        <div className="file-upload-container">
          {!hasFile ? (
            <div className={`file-upload-area ${disabled ? 'disabled' : ''} ${fileError ? 'error' : ''}`}>
              <input
                type="file"
                id={id}
                name={name}
                accept={accept}
                required={required}
                disabled={disabled}
                onChange={handleFileChange}
                className="file-input"
              />
              <div className="file-upload-content">
                <div className="file-upload-icon">
                  <img src={getIcon()} alt={label} className="file-upload-icon-img" />
                </div>
                <div className="file-upload-text">
                  <span className="file-upload-title">Dosya Seç</span>
                  <span className="file-upload-subtitle">{description || 'PDF, JPG, JPEG veya PNG'}</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="file-selected">
              {filePreviews[name] ? (
                <div className="file-preview-container">
                  <div className="file-preview-image">
                    {file?.type.startsWith('image/') ? (
                      <img src={filePreviews[name]} alt="Dosya önizleme" style={{ maxWidth: '100%', maxHeight: '150px', objectFit: 'contain' }} />
                    ) : (
                      <embed src={filePreviews[name]} type="application/pdf" style={{ width: '100%', height: '150px' }} />
                    )}
                  </div>
                  <div className="file-preview-info">
                    <div className="file-details">
                      <span className="file-name">{fileNames[name]}</span>
                      <span className="file-size">
                        {Math.round((file?.size || 0) / 1024)} KB
                      </span>
                    </div>
                    <button
                      type="button"
                      className="file-remove-btn"
                      onClick={removeFile}
                      title="Dosyayı kaldır"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ) : (
                <div className="file-info">
                  <div className="file-icon">
                    <img src={getIcon()} alt={label} className="file-icon-img" />
                  </div>
                  <div className="file-details">
                    <span className="file-name">{fileNames[name]}</span>
                    <span className="file-size">
                      {Math.round((file?.size || 0) / 1024)} KB
                    </span>
                  </div>
                  <button
                    type="button"
                    className="file-remove-btn"
                    onClick={removeFile}
                    title="Dosyayı kaldır"
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>
          )}
          {fileError && (
            <div className="file-error-message">
              <span className="error-icon">⚠️</span>
              <span className="error-text">{fileError}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);

    fetch('https://getform.io/f/bvryopnb', {
      method: 'POST',
      body: formData,
    })
      .then(response => {
        if (response.ok) {
          alert('Başvurunuz başarıyla gönderildi! En kısa sürede sizinle iletişime geçeceğiz.');
          navigate('/tesekkur');
          (e.target as HTMLFormElement).reset();
        } else {
          alert('Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
        }
      })
      .catch(error => {
        console.error('Form submission error:', error);
        alert('Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
      });
  };

  return (
    <div className="page-content">
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Kurye Hizmeti Al
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Kurye ihtiyaçlarınız için bizimle iletişime geçin. Size en uygun çözümü sunalım.
          </p>
        </div>
      </section>



      {/* Features Cards */}
      <section className="features-cards">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" width={24} height={24}>
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Hızlı Teklif</h3>
              <p>Form gönderdikten sonra 48 saat içinde size özel teklif sunuyoruz.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" width={24} height={24}>
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Profesyonel Ekip</h3>
              <p>Deneyimli ve eğitimli kuryelerimizle güvenilir teslimat hizmeti.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" width={24} height={24}>
                  <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Uygun Fiyatlar</h3>
              <p>Rekabetçi fiyatlarla kaliteli kurye hizmeti sunuyoruz.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-header">
              <h2>Kurye Hizmeti Başvuru Formu</h2>
              <p>Lütfen aşağıdaki formu doldurun, size en kısa sürede dönüş yapacağız.</p>
            </div>

            <form className="modern-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="taxNumber">Vergi Numarası</label>
                  <input
                    type="text"
                    id="taxNumber"
                    name="Vergi Numarası"
                    placeholder="Vergi numarası"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="companyName">Firma Adı</label>
                  <input
                    type="text"
                    id="companyName"
                    name="Firma Adı"
                    required
                    placeholder="Firma adı"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="companyAddress">Firma Adresi</label>
                  <input
                    type="text"
                    id="companyAddress"
                    name="Firma Adresi"
                    placeholder="Firma adresi"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="contactPerson">Yetkili Kişi</label>
                  <input
                    type="text"
                    id="contactPerson"
                    name="Yetkili Kişi"
                    required
                    placeholder="Adınız ve soyadınız"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">E-posta</label>
                  <input
                    type="email"
                    id="email"
                    name="E-posta"
                    required
                    placeholder="E-posta adresiniz"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Telefon</label>
                  <input
                    type="tel"
                    id="phone"
                    name="Telefon"
                    required
                    placeholder="Telefon numaranız"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="city">Şehir</label>
                  <select
                    id="city"
                    name="Şehir"
                    required
                    value={formData.city}
                    onChange={handleCityChange}
                  >
                    <option value="">Şehir seçiniz</option>
                    {cities.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="district">İlçe</label>
                  <select
                    id="district"
                    name="İlçe"
                    required
                    disabled={!formData.city}
                    value={formData.district}
                    onChange={handleDistrictChange}
                  >
                    {!formData.city ? (
                      <option value="">Önce şehir seçiniz</option>
                    ) : (
                      <>
                        <option value="">İlçe seçiniz</option>
                        {cityDistrictData[formData.city]?.map((district: string) => (
                          <option key={district} value={district}>{district}</option>
                        ))}
                      </>
                    )}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="sector">Sektör</label>
                  <select
                    id="sector"
                    name="sector"
                    required
                    value={formData.sector}
                    onChange={handleChange}
                  >
                    <option value="">Sektör seçiniz</option>
                    <option value="restoran">Restoran</option>
                    <option value="market">Market</option>
                    <option value="kargo">Kargo</option>
                    <option value="diger">Diğer</option>
                  </select>
                  {/* Formspree için sektörün Türkçesi */}
                  {formData.sector && (
                    <input type="hidden" name="Sektör" value={
                      formData.sector === 'restoran' ? 'Restoran' :
                        formData.sector === 'market' ? 'Market' :
                          formData.sector === 'kargo' ? 'Kargo' :
                            formData.sector === 'diger' ? 'Diğer' : ''
                    } />
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="serviceType">Hizmet Türü Seçimi</label>
                  <select
                    id="serviceType"
                    name="serviceType"
                    required
                    disabled={!formData.sector}
                    value={formData.serviceType}
                    onChange={handleChange}
                  >
                    {!formData.sector ? (
                      <option value="">Önce sektör seçiniz</option>
                    ) : (
                      <>
                        {serviceTypeOptions[formData.sector]?.map(opt => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </>
                    )}
                  </select>
                  {/* Formspree için hizmet türünün Türkçesi */}
                  {formData.serviceType && (
                    <input type="hidden" name="Hizmet Türü" value={
                      serviceTypeOptions[formData.sector]?.find(opt => opt.value === formData.serviceType)?.label || ''
                    } />
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="numberOfPeople">Talep Edilen Kurye Sayısı</label>
                  <input
                    type="number"
                    id="numberOfPeople"
                    name="Talep Edilen Kurye Sayısı"
                    required
                    min="1"
                    placeholder="Kaç kurye"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="startDate">Başlangıç Tarihi</label>
                  <input
                    type="date"
                    id="startDate"
                    name="Başlangıç Tarihi"
                    required
                  />
                </div>
              </div>
              <div className="form-group full-width">
                <label htmlFor="description">Açıklama / Ek Notlar *</label>
                <textarea
                  id="description"
                  name="Açıklama / Ek Notlar"
                  placeholder="Eklemek istediğiniz not veya açıklama"
                  required
                />
              </div>

              {/* Belge Yükleme Alanları */}
              <div style={{ marginTop: '2rem' }}>
                <div className="form-row">
                  <FileUploadField
                    id="vergiLevhası"
                    name="Vergi Levhası"
                    label="Vergi Levhası"
                    required={true}
                    description="PDF, JPG, JPEG, PNG formatlarında, maksimum 5MB"
                  />
                  <FileUploadField
                    id="isyeriFaaliyetBelgesi"
                    name="İşyeri Faaliyet Belgesi"
                    label="İşyeri Faaliyet Belgesi"
                    required={true}
                    description="PDF, JPG, JPEG, PNG formatlarında, maksimum 5MB"
                  />
                </div>
              </div>

              {/* Motopack ile Nasıl Tanıştınız? */}
              <div className="form-row">
                <div className="form-group full-width">
                  <label style={{ fontWeight: 600, marginBottom: 8, display: 'block', marginTop: '0.5rem' }}>Motopack ile Nasıl Tanıştınız? *</label>
                  <div className="radio-group" style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '0.5rem',
                    marginTop: '0.5rem',
                    overflowX: 'auto'
                  }}>
                    {[
                      { value: 'google', label: 'Google' },
                      { value: 'sosyal_medya', label: 'Sosyal Medya' },
                      { value: 'fiziksel_reklamlar', label: 'Fiziksel Reklamlar' },
                      { value: 'tavsiye', label: 'Tavsiye' },
                      { value: 'diger', label: 'Diğer' }
                    ].map(option => (
                      <label key={option.value} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        cursor: 'pointer',
                        padding: '0.5rem 0.75rem',
                        borderRadius: 'var(--radius-md)',
                        border: '1px solid var(--gray-200)',
                        background: formData.discovery === option.value ? 'var(--primary-lightest)' : 'white',
                        transition: 'all 0.3s ease',
                        minWidth: '100px',
                        justifyContent: 'center',
                        whiteSpace: 'nowrap'
                      }}>
                        <input
                          type="radio"
                          name="Motopack ile Nasıl Tanıştınız?"
                          value={option.label}
                          required
                          checked={formData.discovery === option.value}
                          onChange={(e) => setFormData(prev => ({
                            ...prev,
                            discovery: option.value
                          }))}
                          style={{ margin: 0 }}
                        />
                        <span style={{
                          color: formData.discovery === option.value ? 'var(--primary-color)' : 'var(--text-secondary)',
                          fontWeight: formData.discovery === option.value ? '600' : '400'
                        }}>
                          {option.label}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* KVKK ve Bilgi Doğruluğu Onayları */}
              <div className="form-row">
                <div className="form-group full-width">
                  <div className="checkbox-group">
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="kvkkOnay"
                        name="kvkkOnay"
                        required
                        checked={formData.kvkkOnay}
                        onChange={(e) => {
                          if (!e.target.checked) {
                            setFormData(prev => ({
                              ...prev,
                              kvkkOnay: false
                            }));
                          } else {
                            setIsKVKKModalOpen(true);
                          }
                        }}
                      />
                      <label htmlFor="kvkkOnay" style={{ cursor: 'pointer' }}>
                        Kişisel Verilerin Korunması Kanunu (KVKK) metnini okudum ve onaylıyorum. *
                      </label>
                    </div>
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="bilgiDogrulugu"
                        name="bilgiDogrulugu"
                        required
                        checked={formData.bilgiDogrulugu}
                        onChange={(e) => setFormData(prev => ({
                          ...prev,
                          bilgiDogrulugu: e.target.checked
                        }))}
                      />
                      <label htmlFor="bilgiDogrulugu">
                        Sunduğum bilgilerin doğru olduğunu beyan ederim. *
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-actions" style={{ textAlign: 'center', marginTop: '2rem' }}>
                <button type="submit" className="btn btn-primary btn-large" style={{ width: '100%', maxWidth: '300px' }}>Formu Gönder</button>
              </div>
            </form>
          </div>
        </div>
      </section>



      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h2 style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: '#fff',
            marginBottom: '0.75rem',
          }}>
            Acil Çözüm
          </h2>
          <p style={{
            fontSize: '1rem',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '1.5rem',
          }}>
            Acil kurye ihtiyacınız için 24 saat içinde size dönüş yapıyoruz.
          </p>
          <div style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <a
              href="tel:08505325989"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: '#fff',
                color: '#0066CC',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              Hemen Arayın
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=908505325989&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: 'transparent',
                color: '#fff',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                border: '1.5px solid rgba(255,255,255,0.5)',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                e.currentTarget.style.borderColor = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
              }}
            >
              WhatsApp'tan Yazın
            </a>
          </div>
        </div>
      </section>

      {/* KVKK Modal */}
      <KVKKModal
        isOpen={isKVKKModalOpen}
        onClose={() => setIsKVKKModalOpen(false)}
        onAccept={() => setFormData(prev => ({ ...prev, kvkkOnay: true }))}
      />
    </div>
  );
};

export default HizmetAl; 